<template>
ezeze
  <h1>{{$t('message.notfound')}}</h1>
</template>